import React from "react";

/**
 * Shown when a user without `MANAGE_HAPPENING_NOW` lands on either the monitor
 * page or the create workspace. Extracted so both routes render an identical
 * locked state.
 */
export const HappeningNowLocked: React.FC = () => (
  <div
    className="mx-auto max-w-lg rounded-[2rem] border-4 border-[#E5E5E5] bg-white p-8 text-center shadow-[0_8px_0_#E5E5E5] sm:p-10"
    style={{ fontFamily: "'Nunito', system-ui, sans-serif" }}
  >
    <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#FEE2E2] text-3xl">
      🔒
    </div>
    <h1 className="mb-2 text-2xl font-extrabold text-[#3C3C3C] sm:text-3xl">
      Not your dashboard yet
    </h1>
    <p className="text-base font-semibold leading-relaxed text-[#777777]">
      Happening now is for Product and above. Ping an admin if you should be on
      this list.
    </p>
  </div>
);
